import { useState } from 'react';
import { useCoupon } from '../context/CouponContext';
import { formatAmount, STORE_CURRENCY } from '../utils/formatPrice';

type CouponInputProps = {
  subtotal: number;
  currency?: 'EUR' | 'TRY';
};

export default function CouponInput({ subtotal, currency = STORE_CURRENCY }: CouponInputProps) {
  const { appliedCoupon, isValidating, error, applyCoupon, removeCoupon, clearError } =
    useCoupon();
  const [code, setCode] = useState('');

  const handleApply = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await applyCoupon(code, subtotal);
    } catch {
      // error state set in context
    }
  };

  const handleRemove = () => {
    removeCoupon();
    setCode('');
  };

  if (appliedCoupon) {
    return (
      <div className="coupon-applied">
        <div className="coupon-applied-info">
          <strong>{appliedCoupon.code}</strong>
          {appliedCoupon.description && <span>{appliedCoupon.description}</span>}
          <span className="coupon-discount">
            −{formatAmount(appliedCoupon.discountAmount, currency)}
          </span>
        </div>
        <button type="button" className="btn btn-outline btn-sm" onClick={handleRemove}>
          Kaldır
        </button>
      </div>
    );
  }

  return (
    <div className="coupon-input">
      <form className="coupon-input-form" onSubmit={(e) => void handleApply(e)}>
        <input
          type="text"
          value={code}
          onChange={(e) => {
            setCode(e.target.value.toUpperCase());
            clearError();
          }}
          placeholder="Kupon kodu"
          aria-label="Kupon kodu"
          disabled={isValidating}
        />
        <button type="submit" className="btn btn-outline btn-sm" disabled={isValidating || !code.trim()}>
          {isValidating ? '...' : 'Uygula'}
        </button>
      </form>
      {error && <p className="coupon-error">{error}</p>}
    </div>
  );
}
